import { useMemo } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { decisionRequest } from '@/vacancy_request/services/api';

export const usePublicRequestActions = ({ aliasAccount, requisitionHash }) => {
  const queryClient = useQueryClient();
  const refreshPublicRequestState = async () => {
    await queryClient.invalidateQueries({ queryKey: ['vacancyRequestPublicData', aliasAccount, requisitionHash] });
    await queryClient.invalidateQueries({ queryKey: ['vacancyRequestPublicHeader', aliasAccount] });
    await queryClient.invalidateQueries({ queryKey: ['vacancyRequestTemplateConfig', aliasAccount] });
  };

  const approveMutation = useMutation({
    mutationFn: (payload) =>
      decisionRequest({
        ...payload,
        aliasAccount,
        requisitionHash,
        action: 'approve'
      }),
    onSuccess: refreshPublicRequestState
  });

  const modifyMutation = useMutation({
    mutationFn: (payload) =>
      decisionRequest({
        ...payload,
        aliasAccount,
        requisitionHash,
        action: 'update_request'
      }),
    onSuccess: refreshPublicRequestState
  });

  const rejectMutation = useMutation({
    mutationFn: (payload) =>
      decisionRequest({
        ...payload,
        aliasAccount,
        requisitionHash,
        action: 'reject'
      }),
    onSuccess: refreshPublicRequestState
  });

  return useMemo(
    () => ({
      approve: { ...approveMutation, isLoading: approveMutation.isLoading ?? approveMutation.isPending },
      modify: { ...modifyMutation, isLoading: modifyMutation.isLoading ?? modifyMutation.isPending },
      reject: { ...rejectMutation, isLoading: rejectMutation.isLoading ?? rejectMutation.isPending }
    }),
    [approveMutation, modifyMutation, rejectMutation]
  );
};
